import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddDialogComponent } from '../add-dialog/add-dialog.component';
import { AddProposalService } from 'src/app/views/proposals/add-proposal/add-proposal.service';
import { CompetenciesService } from 'src/app/views/competencies/competencies.service';

@Component({
  selector: 'app-dialog-for-competency',
  templateUrl: './dialog-for-competency.component.html',
  styleUrls: ['./dialog-for-competency.component.css']
})
export class DialogForCompetencyComponent {

  public serviceLines: any = [];
  public employeeIds: any = [];
  public employeeSelected: any[] = [];
  public selectedEmployeeIds: any[] = [];
  public isEmployeeSelected: boolean = true;
  public subcompetency: boolean = true;
  public placeholderEmployees: string = "Select Employees";
  subCompetencyControl = new FormControl([]);
  competencies: any[] = [];
  subServiceValues: any = [];
  isCompetencyFiledDisabled: boolean = false;
  competencySelected: any;
  defaultSubCompetency: any;
  public selectedCompetenyID: any;
  selectedSubCompetencies: any[] = [];

  @ViewChild('competencyInput') competencyInput: ElementRef<HTMLInputElement>;
  searchText: string = '';
  from: number = 0;
  size: number;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogForCompetencyComponent>,
    public _service: AddProposalService,
    private _competencyService: CompetenciesService
  ) { }
  ngOnInit(): void {
    this.size = this.data.data.totalEmployees;
    this.getEmployees();
    this.getServiceLines();
    this.subCompetencyControl.valueChanges.subscribe((newValue) => {
      this.subCompetencyControl.setValue(newValue, { emitEvent: false });
    });

  }

  getEmployees() {
    return this._competencyService.GetNoCompetencyData(this.searchText, this.from, this.size).subscribe(x => {
      this.employeeSelected = x.data.items.map(item => ({ name: item.firstName + ' ' + item.lastName + ' (' + item.employeeId + ')', value: item.employeeId }));
    });
  }

  applyFilter(filterValue: any) {
    this.selectedEmployeeIds = filterValue.map(x => x.value);
    this.selectedEmployeeIds.length == 0 ? this.isEmployeeSelected = true : this.isEmployeeSelected = false;

  }


  onCompetencyChange(event) {
    this.selectedCompetenyID = event.value.id;
    this.isCompetencyFiledDisabled = true;
    this.subCompetencyControl.setValue([]);
    this.getSubServiceLineValues();
  }
  getSubServiceLineValues() {
    this._service.getSubServiceLines(this.selectedCompetenyID).subscribe(x => {
      if (this.data.data.listOfCompetencies) {
        let competencyIndex = this.data.data.listOfCompetencies.findIndex(x => x.id == this.selectedCompetenyID);
        if (competencyIndex > -1 && this.data.data.listOfSubCompetencies) {
          const subCompetencies = this.subCompetencyControl.value as any[];
          this.data.data.listOfSubCompetencies[competencyIndex].map(x => x.competencyId = this.selectedCompetenyID);
          if (this.selectedCompetenyID == this.data.data.defaultCompetencyId) {
            subCompetencies.push(...this.data.data.listOfSubCompetencies[competencyIndex].filter(x => x.competencyId && x.competencyId == this.data.data.defaultCompetencyId));
          }
          else {
            subCompetencies.push(...this.data.data.listOfSubCompetencies[competencyIndex]);
          }

          this.subCompetencyControl.setValue(subCompetencies);
        }
      }

      this.subServiceValues = [];
      this.defaultSubCompetency = null;
      x.data.forEach(ser => {
        if (this.data.data.defaultCompetencyId && this.selectedCompetenyID == this.data.data.defaultCompetencyId && ser.id == this.data.data.defaultSubCompetencyId) {
          ser.isDefault = true;
          this.defaultSubCompetency = ser;
        }
        this.subServiceValues.push(ser);
      });
    });
  }

  getServiceLines(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._service.getServiceLines().subscribe(x => {

        x.data.forEach(ser => {
          x = this.serviceLines.some(x => x.name == ser.name);
          if (!x) {
            this.serviceLines.push(ser);

          }
        });
        resolve(this.serviceLines);
      })
    });
  }

  closeDialog() {
    const empIds: any = [];
    for (let i = 0; i < this.selectedEmployeeIds.length; i++) {
      empIds.push(this.selectedEmployeeIds[i])
    }

    let data: any = {
      employeesList: empIds,
      selectedCompetency: this.competencySelected.name,
      selectedSubCompetencies: this.subCompetencyControl.value
    }
    this.dialogRef.close(data);

  }
  close() {
    this.dialogRef.close();
  }
}
